import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { type PeriodRange } from 'src/core/modules/budgets/models/periodRange';

export type PeriodRangesState = {
  periodRanges: PeriodRanges;
};

export type PeriodRanges = { id: string; periodRange: PeriodRange }[];

export const usePeriodRanges = () => {
  const location: { state: PeriodRangesState } = useLocation();
  const initialPeriodRanges = location?.state?.periodRanges ?? [];

  const [periodRanges, setPeriodRanges] =
    useState<PeriodRanges>(initialPeriodRanges);

  return {
    getLocationState: () => ({ periodRanges }),

    setById: (id: string, range: PeriodRange) =>
      setPeriodRanges((previous) => {
        const otherRanges = previous.filter((item) => item.id !== id);
        return [...otherRanges, { id, periodRange: range }];
      }),

    getById: (id: string) =>
      periodRanges.find((pr) => pr.id === id)?.periodRange ?? {
        key: 'overall',
      },
  };
};
